import React from "react";
import SectionShell from "./SectionShell";

export default function SituationChangesSection() {
  return (
    <SectionShell
      id="valtozas"
      testId="situation-changes-section"
      eyebrow="A valódi változás"
      titleStart="Nem mindig a"
      titleAccent="helyzet"
      titleEnd=" változik meg először"
    >
      <p>
        Amikor rálátunk egy mélyen gyökerező működésünkre, gyakran nem az életünk változik meg
        először. Hanem az, ahogyan ránézünk. Ugyanaz a helyzet, kapcsolat, történet. Mégis
        valami más. Amikor kitágul a nézőpontunk, olyan összefüggések is láthatóvá válnak,
        amelyek korábban rejtve maradtak. Ezzel együtt pedig megjelennek új lehetőségek is.
        Nem mindig könnyű szembenézni azzal, amit találunk. Hiszen sokszor éppen azok a minták
        válnak láthatóvá, amelyeket addig természetesnek, sőt megkérdőjelezhetetlennek
        hittünk. Mégis itt kezdődik a valódi változás. Nem akkor, amikor a másik ember
        megváltozik, vagy a körülmények végre úgy alakulnak, ahogy szeretnénk. Hanem abban a
        pillanatban, amikor már nem ugyanazokon a történeteken keresztül nézünk rá az
        életünkre. Ettől a pillanattól kezdve új lehetőségek jelennek meg. Új döntések,
        választások, és utak. Bár a valódi változás belül indul el, idővel megjelenik a
        kapcsolatainkban, a döntéseinkben és az életünkben is. Nem azért, mert erővel
        megváltoztatjuk. Hanem mert mi magunk már más szűrőn keresztül szemléljük.
      </p>
    </SectionShell>
  );
}
